import {SortDirection} from "../../../data-structures/sort";

export default {
    columns                 : _.map(['2','7','12'], id=>({id: id/*, aggregate: null*/})),
    boardViewRowGroupBy     : {
        fieldId         : undefined,
        sortDirection   : SortDirection.ASC,
        params          : {}
    },
    boardViewColumnGroupBy : {
        fieldId         : gd.fields.task.statusId.fieldId,
        sortDirection   : SortDirection.ASC,
        params          : {}
    },
    boardViewSize           : 'medium',
    boardCardColorFieldId   : 'statusId',
    boardViewBorderPosition : 'left',
    systemStatusFilter      : 'all',
    filters                 : {},
    showSubfolders          : true, // show subfolders as separate cards
    showSubTasks            : false,  // false = show counter
    showEmptyColumns        : true,
    showEmptyRows           : true,
};
